import { ReactElement } from 'react';
import { createShellRoutes } from './shell-config';
import { useHttpLoading } from 'shell/hooks/use-http-loading';
import { useMemo } from 'react';
import { useRoutes } from 'react-router-dom';
import { useRouteAuthorization } from 'shell/hooks/use-route-authorization';
import { __ROUTING_BASENAME__ } from 'shell/constants/environment';

/**
 * Funzione per le routes
 * @returns {React.ReactComponentElement} React component
 */
export default function AppRoutes(): ReactElement | null {
  const { addLoading, removeLoading } = useHttpLoading();
  const shellRoutes = useMemo(
    () =>
      createShellRoutes({
        onLoadingStart: addLoading,
        onLoadingEnd: removeLoading,
      }),
    [addLoading, removeLoading]
  );

  const authorizationRoutes = useRouteAuthorization(shellRoutes);

  const routes = useRoutes(authorizationRoutes, __ROUTING_BASENAME__);
  return routes;
}

AppRoutes.displayName = 'routing';
